import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type InternalMessageSearchQueryVariables = Types.Exact<{
  criteria?: Types.InputMaybe<Types.InternalMessageSearchCriteria>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type InternalMessageSearchQuery = {
  __typename?: 'Query';
  internalMessageSearchResults: {
    __typename?: 'InternalMessageSearchResultContainer';
    allResults: {
      __typename?: 'InternalMessageResult';
      totalSearchCount: number;
      messages: Array<{
        __typename?: 'InternalMessage';
        id: string;
        type: Types.MessageType;
        sentForEventId?: string | null;
        messageId?: string | null;
        messageBatchId?: string | null;
        stationeryOrderId?: string | null;
        messageType?: string | null;
        provider: string;
        rawStatus: string;
        fromEmail?: string | null;
        replyToEmail?: string | null;
        originalMessageId?: string | null;
        createAt: { __typename?: 'Date'; milliseconds: number };
        lastStatusUpdate?: { __typename?: 'Date'; milliseconds: number } | null;
        recipient: { __typename?: 'InternalRecipientInfo'; email?: string | null; phoneNumber?: string | null; personId?: string | null; guestKey?: string | null };
        rawStatusHistory: Array<{
          __typename?: 'InternalMessageStatusRecord';
          rawStatus: string;
          statusMessage?: string | null;
          date: { __typename?: 'Date'; milliseconds: number };
        }>;
      }>;
    };
  };
};

export const InternalMessageSearchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InternalMessageSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'InternalMessageSearchCriteria' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internalMessageSearchResults' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'criteria' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allResults' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'offset' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'totalSearchCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createAt' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sentForEventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stationeryOrderId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'messageType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rawStatus' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastStatusUpdate' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipient' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'personId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'fromEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'replyToEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'originalMessageId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rawStatusHistory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'rawStatus' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'date' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'statusMessage' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInternalMessageSearchQuery__
 *
 * To run a query within a React component, call `useInternalMessageSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalMessageSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalMessageSearchQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useInternalMessageSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InternalMessageSearchQuery, InternalMessageSearchQueryVariables>) {
  return ApolloReactHooks.useQuery<InternalMessageSearchQuery, InternalMessageSearchQueryVariables>(InternalMessageSearchDocument, baseOptions);
}
export function useInternalMessageSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InternalMessageSearchQuery, InternalMessageSearchQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<InternalMessageSearchQuery, InternalMessageSearchQueryVariables>(InternalMessageSearchDocument, baseOptions);
}
export type InternalMessageSearchQueryHookResult = ReturnType<typeof useInternalMessageSearchQuery>;
export type InternalMessageSearchLazyQueryHookResult = ReturnType<typeof useInternalMessageSearchLazyQuery>;
export type InternalMessageSearchQueryResult = Apollo.QueryResult<InternalMessageSearchQuery, InternalMessageSearchQueryVariables>;
